import React, { useState } from "react";
import Select from "react-select";
import { components } from "react-select";

const MultiSelector = ({
  isMulti,
  options,
  onChange,
  selectedOption,
  closeMenuOnSelect,
  placeholder,
}) => {
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input type="checkbox" checked={props.isSelected} />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  const customStyles = {
    control: (styles) => ({ ...styles, backgroundColor: "white", width: 300 }),
    menu: ({ width, ...css }) => ({
      ...css,
      width: "300px",
      minWidth: "20%",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: undefined,
        color: "black",
        cursor: "default",
      };
    },
  };

  return (
    <Select
      placeholder={placeholder}
      closeMenuOnSelect={closeMenuOnSelect}
      hideSelectedOptions={false}
      isMulti={isMulti}
      value={selectedOption}
      onChange={onChange}
      options={options}
      components={{ Option }}
      styles={customStyles}
    />
  );
};
export default MultiSelector;
